import { render } from "./ToprankTrade_side.vue?vue&type=template&id=27090bbb"
import script from "./ToprankTrade_side.vue?vue&type=script&lang=js"
export * from "./ToprankTrade_side.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__